(function () {
  'use strict';
  var node = document.querySelector('[data-bw-region-config]');
  if (!node) return;
  var config;
  try { config = JSON.parse(node.textContent); } catch (_) { return; }
  var key = 'bw_region_preference_v1', cancelled = false;
  function read() {
    try { var value = localStorage.getItem(key); if (value) return JSON.parse(value); } catch (_) {}
    var cookie = document.cookie.split('; ').find(function (part) { return part.indexOf(key + '=') === 0; });
    try { return cookie ? JSON.parse(decodeURIComponent(cookie.slice(key.length + 1))) : null; } catch (_) { return null; }
  }
  function save(value) {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch (_) {}
    document.cookie = key + '=' + encodeURIComponent(JSON.stringify(value)) + '; Max-Age=31536000; Path=/; SameSite=Lax; Secure';
  }
  function valid(code) { return config.countries.indexOf(code) !== -1; }
  function remember(code) {
    if (!valid(code)) return;
    cancelled = true;
    save({ source: 'manual', country: code });
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest('button[name="country_code"]');
    if (!button || !button.form) return;
    remember(button.value);
    var hidden = button.form.querySelector('input[type="hidden"][name="country_code"]');
    if (hidden) hidden.value = button.value;
  }, true);
  document.addEventListener('submit', function (event) {
    if (event.target.dataset.bwAutoRegion) return;
    var submitter = event.submitter;
    if (submitter && submitter.name === 'country_code') remember(submitter.value);
  }, true);
  document.addEventListener('change', function (event) {
    if (event.target.matches('select[name="country_code"]')) remember(event.target.value);
  }, true);
  if (read() || (window.Shopify && window.Shopify.designMode)) return;
  try {
    if (localStorage.getItem('selected_country')) {
      save({ source: 'existing-choice', country: config.current });
      return;
    }
  } catch (_) {}
  save({ source: 'checked', country: config.current });
  var controller = new AbortController();
  var timer = setTimeout(function () { controller.abort(); }, 4000);
  fetch(config.root + 'browsing_context_suggestions.json?country[enabled]=true&country[exclude]=' + encodeURIComponent(config.current), {
    credentials: 'same-origin', signal: controller.signal
  }).then(function (response) {
    if (!response.ok) throw new Error('Unavailable');
    return response.json();
  }).then(function (data) {
    var suggestion = (data.suggestions || []).find(function (entry) { return entry.parts && entry.parts.country; });
    var country = suggestion && suggestion.parts.country;
    if (cancelled || (read() || {}).source === 'manual' || !country || !(country.confidence >= 0.9) || !valid(country.handle) || country.handle === config.current) return;
    save({ source: 'automatic', country: country.handle });
    var form = document.createElement('form');
    form.method = 'POST'; form.action = config.action; form.hidden = true; form.dataset.bwAutoRegion = 'true';
    var fields = { _method: 'PUT', form_type: 'localization', country_code: country.handle, return_to: location.pathname + location.search };
    Object.keys(fields).forEach(function (name) {
      var input = document.createElement('input'); input.type = 'hidden'; input.name = name; input.value = fields[name]; form.appendChild(input);
    });
    document.body.appendChild(form);
    HTMLFormElement.prototype.submit.call(form);
  }).catch(function () {}).finally(function () { clearTimeout(timer); });
}());